import "@/App.css";
import "./styles/jamblu.css";
import "./styles/album.css";
import "./styles/drift.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import MusicPage from "./components/MusicPage";
import FilmPage from "./components/FilmPage";
import SocialsPage from "./components/SocialsPage";
import TourPage from "./components/TourPage";
import MerchPage from "./components/MerchPage";
import ExperimentsPage from "./components/ExperimentsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/music" element={<MusicPage />} />
          <Route path="/film" element={<FilmPage />} />
          <Route path="/socials" element={<SocialsPage />} />
          <Route path="/tour" element={<TourPage />} />
          <Route path="/merch" element={<MerchPage />} />
          <Route path="/experiments" element={<ExperimentsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
